import React from 'react';
import {
    Box,
    Button,
    CheckBox,
    Form,
    FormField,
    Heading,
    Layer,
    Spinner,
    Text,
    TextInput
} from 'grommet';
import { Close, Hide, View } from 'grommet-icons';
import createAccount from './utils/http/create-account';

/**
 * 
                             <FormField name="show-password" htmlFor="show-password-id" fill>
                                <Box border={true} hoverIndicator={true}>
                                <CheckBox
                                    pad='small'
                                    fill
                                    name="show-password"
                                    id="show-password-id"
                                    label="Show password"
                                    checked={showPassword}
                                    reverse={true}
                                    onChange={event => setShowPassword(event.target.checked)}
                                ></CheckBox>
                                </Box>
                            </FormField>
 */

import http from './utils/http';
import ProfileModel from './profiles/profile-model';

const SignUp = ({ setShowSignUp, setView, setLoggedIn, setUser }) => {
    const [account, setAccount] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [contact, setContact] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [showFail, setShowFail] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const handleSignUp = async (formData) => {
        try {
            console.log("trace: handleSignUp");
            setLoading(true);
            // Call the registerUser function with the form data

            console.log(formData);
            const registrationResponse = await http.registerUser(formData);

            if (registrationResponse.status) {
                // Registration successful
                console.log(registrationResponse.userId);
                const user = new ProfileModel(formData);
                console.log(user);
                setUser(user);
                setLoggedIn(true);
                setShowSignUp(false);
                setLoading(false);
                setView('upload');
            } else {
                // Registration failed
                setLoading(false);
                console.error('Registration failed:', registrationResponse.message);
                // Handle the error or show an error message to the user
            }
        } catch (error) {
            setLoading(false);
            console.error('Error during registration:', error);
            // Handle other errors if needed
        }
    };

    return (
        <Layer
            onEsc={() => setShowSignUp(false)}
            onClickOutside={() => setShowSignUp(false)}
        >
            <Box pad="medium">
                <Box direction="row" align="start" gap="small">
                    <Box gap="medium">
                        <Heading level={2} margin="none">
                            Sign Up
                        </Heading>
                        <Form onSubmit={({ value }) => handleSignUp(value)}>
                            <FormField name="username" htmlFor="username-id">
                                <TextInput id="username-id" name="username" placeholder="Username"/>
                            </FormField>
                            <FormField name="password" htmlFor="claim3-password-id">
                                <TextInput
                                    id="claim3-password-id"
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    icon={showPassword ? <View/> : <Hide/>}
                                    reverse={true}
                                    value={password}
                                    onChange={event => setPassword(event.target.value)}
                                />
                            </FormField>
                            <FormField name="firstName" htmlFor="first-name-id">
                                <TextInput id="first-name-id" name="firstName" placeholder="First name"/>
                            </FormField>
                            <FormField name="lastName" htmlFor="last-name-id">
                                <TextInput id="last-name-id" name="lastName" placeholder="Last name"/>
                            </FormField>
                            <FormField name="email" htmlFor="email-id">
                                <TextInput
                                    width="medium"
                                    id="email-id"
                                    name="email"
                                    placeholder="Mobile number or email"
                                    value={contact}
                                    onChange={event => setContact(event.target.value)}
                                />
                            </FormField>
                            <Button primary label ="Sign Up" type="submit"/>
                        </Form>
                        { loading && <Spinner alignSelf='center' size='medium'/>}
                        { showFail && <Text style={{color: 'red'}}>Failed to create your claim3 account</Text>}
                    </Box>
                    <Button
                        icon={<Close />}
                        onClick={() => {
                            setShowSignUp(false)
                        }}
                        a11yTitle={`Sign up UI`}
                        autoFocus
                    />
                </Box>
            </Box>
        </Layer>
    )
}

export default SignUp;